// // CounterReducer.js
// import { Add, Remove } from '@mui/icons-material';
// import { Box, IconButton, TextField } from '@mui/material';
// import React, { useReducer } from 'react';
// import styled from 'styled-components';


// const QuantityBox = styled(Box)(({ theme }) => ({
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     width: "200px",
// }));
// // Reducer function
// const counterReducer = (state, action) => {
//     switch (action.type) {
//         case 'INCREMENT':
//             return { count: Math.min(state.count + 1, 10) };;
//         case 'DECREMENT':
//             return { count: Math.max(state.count - 1, 0) };
//         default:
//             return state;
//     }
// };

// const Test1 = () => {
//     // useReducer returns the current state and a dispatch function
//     const [state, dispatch] = useReducer(counterReducer, { count: 0 });

//     return (
//         <div>
//             <h1>Counter using useReducer</h1>
//             <QuantityBox>
//                 <IconButton><Add onClick={() => dispatch({ type: 'INCREMENT' })} /></IconButton>
//                 <TextField
//                     name="quantity"
//                     type="number"
//                     variant="outlined"
//                     //disabled
//                     value={state.count}                       
//                    style={{ width: "100px" }}
//                 />

//                 <IconButton><Remove onClick={() => dispatch({ type: 'DECREMENT' })} /></IconButton>
//             </QuantityBox>
//         </div>
//     );
// };

// export default Test1;

import React, { useState, useCallback } from 'react';

const Test1 = () => {
  const [count, setCount] = useState(0);

  // Define a memoized increment function using useCallback
  const increment = useCallback(() => {
    setCount((prevCount) => prevCount + 1);
  }, []); // Empty dependency array means the function won't change between renders

  // Define a memoized decrement function using useCallback
  const decrement = useCallback(() => {
    setCount((prevCount) => prevCount - 1);
  }, []); // Empty dependency array means the function won't change between renders

  return (
    <div>
      <h1>Counter with useCallback</h1>
      <p>Count: {count}</p>
      {/* Pass the memoized functions to child components */}
      <Button onClick={increment}>Increment</Button>
      <Button onClick={decrement}>Decrement</Button>
    </div>
  );
};

// Button component for demonstration
const Button = ({ onClick, children }) => {
  console.log(`Rendering button: ${children}`);
  return <button onClick={onClick}>{children}</button>;
};

export default Test1;

